import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    body: 'This step allows us to make sure that you are the one who requested the closure of your account.',
    title: 'Confirm with your secret code',
  },
  fr: {
    body: 'Votre code secret est une sécurité supplémentaire pour nous assurer que vous êtes bien à l’origine de cette demande.',
    title: 'Confirmez avec votre code secret',
  },
});

export default locales;
